import script from "./membership.vue?vue&type=script&setup=true&lang=js"
export * from "./membership.vue?vue&type=script&setup=true&lang=js"

import "./membership.vue?vue&type=style&index=0&id=5b1053c3&lang=scss"
import "./membership.vue?vue&type=style&index=1&id=5b1053c3&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1053c3"]])

export default __exports__